'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addSeconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addSeconds.js
// module id = 472
// module chunks = 0